import { useCallback, useEffect, useMemo, useState } from "react";
import { Col, Container, Dropdown, Row, Tab } from "react-bootstrap";
import TableLayout from "../../../../components/TableLayout";
import {
  CommonSelect,
  CstmPagination
} from "../../../../components/Common/Common";
import { useFavouriteSchoolClientMutation, useGetSchoolClientsListQuery } from "store/services/clients/school.client";
import LoadingIndicator from "components/shared/LoadingIndicator";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { userFullName } from "helpers/common";
import TableHeader from "components/shared/FormComponents/TableHeader";
import SearchListCheckbox from "components/shared/SearchListCheckbox";
import {
  useDisciplinesLookupQuery,
  useDivisionLookupQuery,
  useLazyAssignedSchoolsLookupQuery,
  useLazySchoolLookupQuery
} from "store/services/utility";
import {
  SCHOOL_CLIENT_DETAIL
} from "config/paths";
import moment from "moment";
import ClientsReportMenu from "components/shared/ReportComponents/ClientsReportMenu";
import { classroomReportStatusOptions, CLIENT_STATUS_OPTION, GRADE_OPTIONS } from "config/constants";
import { useDispatch, useSelector } from "react-redux";
import { initialFilterState, schoolClientsFilter } from "store/slices/filter";
import { cloneDeep, debounce } from "lodash";
import { usePersistentState } from "hooks/usePersistentState";
import TableLayoutV2 from "components/TableLayoutV2";
import { Star } from "react-feather";

const ClientSchool = () => {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = usePersistentState("school:page", 1);
  const [pageSize, setPageSize] = useState(10);
  const filter = useSelector(state => state?.filter?.schoolClientsFilter);
  const [schoolOptions, setSchoolOptions] = useState([]);

  const { data: schoolDivisonsList } = useDivisionLookupQuery();
  const { data: disciplinesList, isLoading: disciplinesLoading } = useDisciplinesLookupQuery();

  const { data, isLoading, isError, isFetching } = useGetSchoolClientsListQuery(
    { page: currentPage, limit: pageSize, ...filter }
  );
  const schoolClients = data?.records;
  const totalRecords = data?.totalRecords || 0;
  const totalPages = Math.ceil(totalRecords / pageSize);

  const [getSchools, { isFetching: schoolsLoading }] = useLazyAssignedSchoolsLookupQuery()
  const [favouriteClient, { isLoading: favouriteClientLoading }] = useFavouriteSchoolClientMutation()


  const gradeOptions = useMemo(() => [{ label: "Select Grade", value: "" }, ...GRADE_OPTIONS], []);

  const column = [
    {
      head: <div onClick={() => dispatch(schoolClientsFilter({ ...filter, sort: filter?.sort?.column == "is_favorite" ? { column: "lastname", direction: "ASC" } : { column: "is_favorite", direction: "desc" } }))}>{filter?.sort?.column == "is_favorite" ? <Star fill="#93278F" stroke="#93278F" width={18} /> : <Star width={18} stroke="#8F8F8F" />}</div>,
      accessor: "is_favorite",
      isComponent: true,
      component: (item, ind) => (
        <h6 className="m-0 text-capitalize d-flex align-items-center gap-2"><div className="cursor-pointer" onClick={(e) => { e.stopPropagation(); handleFavouriteReport(item?.client_detail?.id, item?.client_detail?.is_favorite ? 0 : 1) }}>{item?.client_detail?.is_favorite ? <Star fill="#93278F" stroke="#93278F" width={18} /> : <Star width={18} stroke="#8F8F8F" />}</div></h6>
      ),
    },
    {
      head: (
        <>
          <div className="d-flex align-items-center">Last Name</div>
        </>
      ),
      accessor: "lastname",
      isComponent: true,
      sorter: true,
      component: (item, ind) => (
        <div className="d-flex align-itmes-center">
          <h6 className="m-0 fw-sbold">{item.lastname}</h6>
        </div>
      ),
    },
    {
      head: "First Name",
      accessor: "firstname",
      isComponent: true,
      sorter: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-sbold">{item.firstname}</h6>
      ),
    },
    {
      head: "DOB",
      accessor: "dob",
      isComponent: true,
      sorter: true,
      component: (item, ind) => (
        <div>{moment(item?.client_detail?.dob).format("DD/MM/YYYY")}</div>
      ),
    },
    {
      head: <div className="w-100 text-center">Grade</div>,
      accessor: "grade",
      sorter: true,
      component: (item, ind) => <div className="w-100 text-center">{item?.client_detail?.grade || "--"}</div>,
    },
    {
      head: "School",
      accessor: "school",
      sorter: true,
      component: (item, ind) => (
        <>
          {item?.client_detail?.client_school_detail?.client_school?.name ||
            "--"}
        </>
      ),
    },
    // ...useMemo(() => {
    //   return disciplinesList?.map((discipline) => {
    //     if (discipline?.is_default == "yes") return {
    //       head: discipline.assign_term,
    //       accessor: discipline.assign_term,
    //       component: (item) => (
    //         <>
    //           {assignedTherapistName(
    //             discipline.assign_term,
    //             item?.clientPendingCaseload?.clientCaseloadTherapist
    //           ) || "--"}
    //         </>
    //       ),
    //     }
    //   })?.filter(Boolean) || []
    // }, [disciplinesList]),
    {
      head: "Disciplines",
      accessor: "disciplines",
      component: (item, ind) => (
        <>
          <div>
            {
              item?.clientPendingCaseload?.clientCaseloadTherapist?.map((therapist, index) =>
                <span
                  className={`discipline-${therapist?.caseDiscipline?.assign_term}-capsule-bcg`}
                  style={{ padding: "7px 10px", marginRight: "3px", borderRadius: "8px" }}>
                  {therapist?.caseDiscipline?.assign_term}
                </span>)
            }
          </div>
        </>
      ),
    },
    {
      head: "Account Status",
      accessor: "status",
      sorter: true,
      component: (item, ind) => (
        <div style={{ color: item?.status == "active" && '#55A215', fontStyle: ["inactive", 'discharged']?.includes(item?.status) && "italic" }} className="text-capitalize">
          {(item?.status || "--")}
        </div>
      ),
    },
    {
      // head: "Action",
      accessor: "",
      isComponent: true,
      component: (item, index) => (
        item?.status != "discharged" &&
        <ClientsReportMenu
          disabled={item?.status != "active"}
          v2={true}
          index={index}
          client={item}
        />
      ),
    },
  ];

  const handleFilterChange = (key) => (value) => {
    dispatch(schoolClientsFilter({ ...filter, [key]: value }))
    setCurrentPage(1); // Reset to first page when filter changes
  };

  const resetFilter = () => {
    dispatch(schoolClientsFilter(initialFilterState.schoolClientsFilter));
    setCurrentPage(1)
  };

  const handlePageChange = (page) => {
    window.scrollTo(0, 0);
    setCurrentPage(page);
  };

  const handlePageSizeChange = (e) => {
    setPageSize(parseInt(e.target.value, 10));
    setCurrentPage(1); // Reset to first page when page size changes
  };

  const handleGetRowColor = (item) => {
    console.log('item ', item)
    if (item?.status == "discharged") {
      return "rowYellow";
    }
    else if (item?.status == "inactive") {
      return "rowGray";
    }
  }

  const getSchoolOptions = async (search) => {
    try {

      const result = await getSchools(search);
      if (result?.data?.[0]?.id) {
        const data = result?.data?.map((item) => ({ label: item?.name, value: item?.id }))
        setSchoolOptions(data);
      }
    } catch (error) { console.log("Error Getting school options"); };

  };

  const handleFavouriteReport = async (id, favorite) => {
    const data = {
      favorite
    }
    try {
      await favouriteClient({ data, id }).unwrap()
    } catch (error) {
      console.log('error making the client favourite: ', error)
    }
  }

  const handleSearchChange = useCallback(debounce((value) => {

    handleFilterChange("search")(value);

  }, 500), [handleFilterChange, 500]);

  const handleSearch = useCallback(debounce((value) => {
    if (value) getSchoolOptions(value);
  }, 500), []);

  useEffect(() => {

    if (schoolDivisonsList?.length && filter?.division) {
      const division = cloneDeep(schoolDivisonsList?.find(x => x.id == filter?.division));
      setSchoolOptions(division?.schools || []);

    }
  }, [schoolDivisonsList, filter]);

  useEffect(() => {
    getSchoolOptions()
  }, [])
  return (
    <>
      <section className="client position-relative py-4">
        <Container fluid>
          {isLoading || disciplinesLoading ? <div style={{ height: "200px" }}>  <LoadingIndicator /></div> : <Row>
            <Col lg="12" className="my-2">
              {/* <TableHeader
                heading={"School Caseload"}
                filter={filter}
                handleFilterChange={handleFilterChange}
                resetFilter={resetFilter}
                searchPlaceholder="Client First, Last Name"
                filterComponent={
                  <>
                    <li className="">
                      <SearchListCheckbox

                        type="radio"
                        inputPlaceholder={"Search Board Name"}
                        title={schoolDivisonsList?.find(x => x.id == filter?.division)?.title || "School Division"}
                        options={schoolDivisonsList?.map((item) => ({
                          label: item?.title,
                          value: item?.id,
                        }))}
                        handleChange={(selected) => {
                          handleFilterChange("division")(selected);
                        }}
                      />
                    </li>
                    <li>
                      <Dropdown onSelect={(selected) => handleFilterChange("school")({ value: selected })}>
                        <Dropdown.Toggle
                          className={`ps-3 text-capitalize border-start rounded-0 pe-0 border-0 themeBlue d-flex align-items-center`}
                          variant="transparent"
                          id="dropdown-basic"
                        >
                          <div className="d-flex">
                            <div style={{ width: "120px", overflow: "hidden", textOverflow: "ellipsis", boxSizing: "border-box" }}>
                              {schoolOptions.find(x => x.id == filter?.school?.value)?.name || "Select School"}
                            </div>
                            <span className="icn" style={{ marginRight: "20px" }}>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="8"
                                viewBox="0 0 12 8"
                                fill="none"
                              >
                                <path
                                  d="M1.415 0.298828L6 4.731L10.585 0.298828L12 1.66666L6 7.46666L0 1.66666L1.415 0.298828Z"
                                  fill="black"
                                />
                              </svg>
                            </span>
                          </div>
                        </Dropdown.Toggle>

                        <Dropdown.Menu style={{ maxHeight: "250px", overflowY: "auto" }}                        >
                          {schoolOptions?.length ? schoolOptions?.map((item, index) => {
                            return <Dropdown.Item eventKey={item?.id}>{item?.name}</Dropdown.Item>
                          }) : <>
                            <Dropdown.Item disabled eventKey={""}>No Record Found</Dropdown.Item>

                          </>
                          }
                        </Dropdown.Menu>
                      </Dropdown>
                    </li>
                    <li>
                      <Dropdown onSelect={(selected) => handleFilterChange("grade")(selected)}>
                        <Dropdown.Toggle
                          className={`ps-3 text-capitalize border-start rounded-0 pe-0 border-0 themeBlue d-flex align-items-center`}
                          variant="transparent"
                          id="dropdown-basic"
                        >
                          <div className="d-flex">
                            <div style={{ width: "120px", overflow: "hidden", textOverflow: "ellipsis", boxSizing: "border-box" }}>
                              {gradeOptions.find(x => x.value == filter?.grade)?.label || "Select Grade"}
                            </div>
                            <span className="icn" style={{ marginRight: "20px" }}>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="8"
                                viewBox="0 0 12 8"
                                fill="none"
                              >
                                <path
                                  d="M1.415 0.298828L6 4.731L10.585 0.298828L12 1.66666L6 7.46666L0 1.66666L1.415 0.298828Z"
                                  fill="black"
                                />
                              </svg>
                            </span>
                          </div>
                        </Dropdown.Toggle>

                        <Dropdown.Menu style={{ maxHeight: "250px", overflowY: "auto" }}                        >
                          {gradeOptions?.length ? gradeOptions?.map((item, index) => {
                            return <Dropdown.Item key={index} eventKey={item?.value}>{item?.label}</Dropdown.Item>
                          }) :
                            <>
                              <Dropdown.Item disabled eventKey={""}>No Record Found</Dropdown.Item>
                            </>
                          }
                        </Dropdown.Menu>
                      </Dropdown>
                    </li>
                  </>
                }
              ></TableHeader> */}
              <Row className="reports-v2 my-3 gap-2 gap-lg-0 d-flex justify-content-end classroom-conslutation">
                <Col  md='4'>
                  <div className="d-flex w-100 align-items-center gap-3">
                    <label className="discharge-screen-label mb-0">School</label>
                    <CommonSelect
                      placeholder={"Choose one"}
                      option={schoolOptions}
                      onChange={(e) => handleFilterChange("school")(e)}
                      value={filter?.school}
                      onInputChange={(val) => handleSearch(val)}
                      isFilterV2
                      isClearable
                      styles={{
                        container: (provided) => ({
                          ...provided,
                          width: "100%", // ✅ Ensures the whole Select container is full width
                        }),
                      }}
                      isLoading={schoolsLoading}
                    />
                  </div>
                </Col>
                <Col md='3' lg="2">
                  <div className="d-flex w-100 align-items-center gap-3">
                    <label className="discharge-screen-label mb-0">Grade</label>
                    <CommonSelect
                      placeholder={"Select"}
                      option={GRADE_OPTIONS}
                      onChange={(e) => handleFilterChange("grade")(e)}
                      value={filter?.grade}
                      // onInputChange={(val) => handleSearch(val)}
                      isFilterV2
                      isClearable
                      styles={{
                        container: (provided) => ({
                          ...provided,
                          width: "100%", // ✅ Ensures the whole Select container is full width
                        }),
                      }}
                    // isLoading={schoolsLoading}
                    />
                  </div>
                </Col>
                <Col md='3' lg="2">
                  <div className="d-flex w-100 align-items-center gap-3">
                    <label className="discharge-screen-label mb-0">Status</label>
                    <CommonSelect
                      placeholder={"Select"}
                      option={CLIENT_STATUS_OPTION}
                      onChange={(e) => handleFilterChange("status")(e)}
                      value={filter?.status}
                      isFilterV2
                      // isClearable
                      // isLoading={schoolListLoading || schoolListFetching}
                      styles={{
                        container: (provided) => ({
                          ...provided,
                          width: "100%", // ✅ Ensures the whole Select container is full width
                        }),
                      }}
                    />
                  </div>
                </Col>
                <Col lg="4">
                  <div className="d-flex w-100 align-items-center gap-3">
                    <label className="discharge-screen-label mb-0">Search</label>
                    <input
                      onChange={(e) => handleSearchChange(e.target.value)}
                      className={` readonly-box h-auto search-input-filter-v2`}
                      placeholder="Type..."
                      defaultValue={filter?.search}
                    />
                  </div>
                </Col>
              </Row>
              <div className="table-outer">
                {isError ? (
                  <ErrorComponent />
                ) : (
                  <>
                    {(isFetching || favouriteClientLoading) && <LoadingOverlay />}
                    {/* <TableLayout
                      data={schoolClients}
                      column={column}
                      url={SCHOOL_CLIENT_DETAIL.replace("/:id", "")}
                    // url={"/manage-team/therapist-profiles/detail/"}
                    /> */}
                    <TableLayoutV2
                      data={schoolClients}
                      column={column}
                      filter={filter}
                      url={SCHOOL_CLIENT_DETAIL.replace("/:id", "")}
                      handleSort={handleFilterChange("sort")}
                      handleGetRowColor={handleGetRowColor}
                    />
                  </>
                )}
                <CstmPagination
                  totalPages={totalPages}
                  className={'paginationV2'}
                  activePage={currentPage}
                  handlePageChange={handlePageChange}
                />
              </div>
            </Col>
          </Row>}
        </Container>
      </section>
    </>
  );
};

const assignedTherapistName = (term, data) => {
  if (!data?.length) {
    return null;
  }
  const caseload = data?.find((item) => item?.caseDiscipline?.assign_term === term);
  const therapist = caseload?.clientCaseloadMapping?.find((item) => item?.caseTherapist?.therapist_detail?.type === "veteran")?.caseTherapist;
  return userFullName(therapist);
};

export default ClientSchool;
